/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useRef, useState } from 'react'

import Vtabs from '../../../components/tabs/vtabs'
import usePascodeMetadata from '../../../hooks/use-pascode-metadata'
import { MetadataContext } from '../../../store/metadata-context-provider'
import { RoleContext } from '../../../store/role-context-provider'
import { ALL_SELECT_OPTION, ALL_SELECT_OPTION_STRING } from '../../../utils/constants/global-constants'
import SettingsAnnouncements from './settings-announcements/settings-announcements'
import SettingsCalendar from './settings-calendar/settings-calendars'
import SettingsKnowledgeBase from './settings-knowledgebase/settings-knowledge-base'
import SettingsPMG from './settings-pmg/settings-pmg'
import SettingsPOC from './settings-poc/settings-poc'
import SettingsQA from './settings-qa/settings-qa'
import SettingsQuicklinks from './settings-quicklinks/settings-quicklinks'

const ContentManagement = ({ setActiveTab }: any) => {
  const roleContext = useContext(RoleContext)

  
  const visibleSquadrons: {
    ACOwner: number[]
    CPOwner: string[],
    Leadership: string[],
    MAJCOMOwner: string[],
    MPFOwner: string[],
    SectionChief: any[]
    SectionOwner: any[]
  } = {
    ACOwner: [],
    CPOwner: [],
    Leadership: [],
    MAJCOMOwner: [],
    MPFOwner: [],
    SectionChief: [],
    SectionOwner: []

  }

  const { pascodeMetadata } = usePascodeMetadata({
    IsArchived: false
  })
  const { majcoms, sections } = useContext(MetadataContext)

  const [assignedComponentOptions, setAssignedComponentOptions] = useState<any>(
    []
  )

  const [initialMajcomOptions, setInitialMajcomOptions] = useState<any[]>([])
  const [initialSectionOptions, setInitialSectionOptions] = useState<any[]>([])
  const [initialSquadronOptions, setInitialSquadronOptions] = useState<any[]>([])

  roleContext.userGroups.map((group: string) => {
    const splitGroup: string[] = group.split('-')
    if (splitGroup[2] === 'CP Owner') {
      visibleSquadrons.CPOwner.push(splitGroup[0])
    } else if (splitGroup[3] === 'Owner') {
      visibleSquadrons.SectionOwner.push({
        section: splitGroup[2],
        squadron: splitGroup[0],
      })
    } else if (splitGroup[2] === 'MPF Owner') {
      visibleSquadrons.MPFOwner.push(splitGroup[0])
    } else if (splitGroup[2] === 'Leadership') {
      visibleSquadrons.Leadership.push(splitGroup[0])
    } else if (splitGroup[3] === 'Section Chief') {
      visibleSquadrons.SectionChief.push({
        section: splitGroup[2],
        squadron: splitGroup[0],
      })
    } else if (group.includes('Owner')) {
      switch (group) {
        case 'RegAF Owner':
          visibleSquadrons.ACOwner.push(143)
          break
        case 'AETC Owner':
          visibleSquadrons.ACOwner.push(144)
          break
        case 'ANG Owner':
          visibleSquadrons.ACOwner.push(145)
          break
        default:
          visibleSquadrons.MAJCOMOwner.push(splitGroup[0].split(' ')[0])
          break
      }
    }
  })

  useEffect(() => {
    if (pascodeMetadata.length > 0) {
      const assignedCompOptions = [
        ...pascodeMetadata.filter((pascode) => {
          let containsSquadron = false

          Object.keys(visibleSquadrons).forEach((key) => {
            if (visibleSquadrons[key].length > 0) {
              const formattedSquadron: string = pascode?.ServicingOrganization.replace('MPF', 'FSS')
              if (visibleSquadrons[key].includes(formattedSquadron) ||
                visibleSquadrons[key]
                  .some((e) => e.squadron === formattedSquadron) ||
                visibleSquadrons.MAJCOMOwner.includes(pascode?.ServicingMAJCOM) ||
                (visibleSquadrons.ACOwner.includes(
                  pascode?.AssignedComponentCode
                ))) {
                containsSquadron = true
              }
            }
          })
          return containsSquadron || roleContext?.isCPOwner
        }).map((component) => ({
          label: component['AssignedComponent/MetadataValue'],
          value: component.AssignedComponentCode,
        })),
      ]
      const formattedComponentOptions: any = [
        ...Object.values(
          assignedCompOptions.reduce((acc, obj) => ({
            ...acc,
            [obj.value]: obj
          }), {}))]
          
      const majOptions: any[] = [
        ...pascodeMetadata.filter((majcom) => {
          let containsSquadron = false

          Object.keys(visibleSquadrons).forEach((key) => {
            if (visibleSquadrons[key].length > 0) {
              const formattedSquadron: string = majcom?.ServicingOrganization.replace('MPF', 'FSS')
              if (visibleSquadrons[key].includes(formattedSquadron) ||
                visibleSquadrons[key]
                  .some((e) => e.squadron === formattedSquadron) ||
                visibleSquadrons.MAJCOMOwner.includes(majcom?.ServicingMAJCOM) ||
                (visibleSquadrons.ACOwner.includes(
                  majcom?.AssignedComponentCode
                ))) {
                containsSquadron = true
              }
            }
          })

          return containsSquadron || roleContext?.isCPOwner
        }).map((pascode) => {
          const majcomCode = majcoms.filter((majcom) => 
            majcom.MAJCOM === pascode.ServicingMAJCOM
          )[0]?.MAJCOMCode
          return {
          assignedComponentCode: pascode.AssignedComponentCode,
          label: pascode.ServicingMAJCOM,
          squadron: pascode?.ServicingOrganization.replace('MPF', 'FSS'),
          value: majcomCode,
        }}),
      ]
      const formattedMajcom: any[] = [
        ...Object.values(
          majOptions.reduce((acc, obj) => {
            if (!acc[obj.value]) {
              acc[obj.value] = { ...obj, squadron: new Set()}
            }
      
            // Combine the squadron values for each unique `value`
            // Append the new squadron with a space separator
            acc[obj.value].squadron.add(obj.squadron)
            
            return acc
          }, {}))].map((item) => ({
            ...item,
            squadron: [...item.squadron]
          }))
      const filteredPascodes: any[] = pascodeMetadata.filter((pascode) => {
        const formattedSquadron: string = pascode?.ServicingOrganization.replace('MPF', 'FSS')

        return visibleSquadrons.SectionChief.some((e) => e.squadron === formattedSquadron) ||
          visibleSquadrons.SectionOwner.some((e) => e.squadron === formattedSquadron)
      })

      const formatPascodesForSection: any[] = [
        ...Object.values(
          filteredPascodes.reduce((acc, obj) => ({
            ...acc,
            [obj.ServicingOrganization]: obj
          }), {}))]

      const sectOptions: any[] = [
        ...sections.filter((section) => {
          let containsSquadron = false

          Object.keys(visibleSquadrons).forEach((key) => {
            if (visibleSquadrons[key].length > 0) {
              const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')
              formatPascodesForSection.filter((pascode) => {
                pascode?.ServicingOrganization.replace('MPF', 'FSS')
                return visibleSquadrons[key]
                .some((e) => e.squadron === formattedSection)
              }).map((e) => e.AssignedComponentCode)
              if (key === 'SectionChief' || key === 'SectionOwner') {
                if (visibleSquadrons[key]
                  .some((e) => e.section === formattedSection)) {
                  containsSquadron = true
                }
              }
            }
          })

          return containsSquadron ||
            roleContext?.isCPOwner ||
            roleContext?.isMPFOwner ||
            roleContext?.isLeadership ||
            roleContext?.isMAJCOMOwner ||
            roleContext?.isAssignedComponentOwner
        }).map((section) => {
          let squadron = ''
          let majcom = ''
          Object.keys(visibleSquadrons).forEach((key) => {
            if (visibleSquadrons[key].length > 0) {
              const formattedSection: string = section?.ShortName?.replace('MPF', 'FSS')

              formatPascodesForSection.filter((pascode) => {
                pascode?.ServicingOrganization.replace('MPF', 'FSS')
                return visibleSquadrons[key]
                .some((e) => e.squadron === formattedSection)
              }).map((e) => e.AssignedComponentCode)
              if (key === 'SectionChief' || key === 'SectionOwner') {
                squadron = visibleSquadrons[key]
                  .filter((e) => e.section === formattedSection)[0]?.squadron || ''
                majcom = formattedMajcom.filter((e) => 
                  squadron.includes(e.squadron)
                )[0]?.value
              }
            }
          })
          return {
            label: section?.Section,
            majcom: majcom || '',
            squadron: squadron || '',
            value: section?.SectionCode,
          }
        }),
      ]

      const formattedSections: any[] = [
        ...Object.values(
          sectOptions.reduce((acc, obj) => ({
            ...acc,
            [obj.value]: obj
          }), {}))]

      const squadOptions: any = []
        formattedMajcom.map((majcom) => {
          majcom?.squadron?.map((item) => {
            squadOptions.push({
              label: item,
              value: item
            })
          })
        })
      
      const formattedSquadrons: any[] = [
        ...Object.values(
          squadOptions.reduce((acc, obj) => ({
            ...acc,
            [obj.value]: obj
          }), {}))]

      if (formattedMajcom.length > 1 && formattedMajcom[0].value !== -1) {
        formattedMajcom.unshift(ALL_SELECT_OPTION)
      }

      if (formattedComponentOptions.length > 1 && formattedComponentOptions[0].value !== -1) {
        formattedComponentOptions.unshift(ALL_SELECT_OPTION)
      }

      if (formattedSections.length > 1 && formattedSections[0].value !== -1) {
        formattedSections.unshift(ALL_SELECT_OPTION)
      }

      if (formattedSquadrons.length > 1 && formattedSquadrons[0].value !== -1) {
        formattedSquadrons.unshift(ALL_SELECT_OPTION_STRING)
      }

      setAssignedComponentOptions(formattedComponentOptions)
      setInitialMajcomOptions(formattedMajcom)
      setInitialSectionOptions(formattedSections)
      setInitialSquadronOptions(formattedSquadrons)
    }
  }, [pascodeMetadata])

  const [tableItems, setTableItems] = useState([
    {
      content: <SettingsAnnouncements 
      assignedComponentOptions={assignedComponentOptions}
      initialMajcomOptions={initialMajcomOptions}
      initialSectionOptions={initialSectionOptions} 
      initialSquadronOptions={initialSquadronOptions}
      roleContext={roleContext}
      visibleSquadrons={visibleSquadrons}
      />,
      icon: 'icon-announcements circled-icon font-13 me-1',
      isActive: 'true',
      tabID: 0,
      tabTitle: 'Announcements',
    },
    {
      content: <SettingsCalendar 
      assignedComponentOptions={assignedComponentOptions}
      initialMajcomOptions={initialMajcomOptions}
      initialSectionOptions={initialSectionOptions} 
      roleContext={roleContext}
      visibleSquadrons={visibleSquadrons}
      />,
      icon: 'icon-calendar circled-icon font-13 me-1',
      isActive: 'false',
      tabID: 1,
      tabTitle: 'Calendar',
    },
    {
      content: <SettingsKnowledgeBase 
      assignedComponentOptions={assignedComponentOptions}
      initialMajcomOptions={initialMajcomOptions}
      initialSectionOptions={initialSectionOptions}
      initialSquadronOptions={initialSquadronOptions}
      roleContext={roleContext}
      visibleSquadrons={visibleSquadrons}
      />,
      icon: 'icon-knowledge-graph circled-icon font-14 me-1',
      isActive: 'false',
      tabID: 2,
      tabTitle: 'Knowledge Base',
    },
    {
      content: <SettingsPOC 
      assignedComponentOptions={assignedComponentOptions}
      initialMajcomOptions={initialMajcomOptions}
      initialSectionOptions={initialSectionOptions} 
      initialSquadronOptions={initialSquadronOptions}
      roleContext={roleContext}
      visibleSquadrons={visibleSquadrons}
      />,
      icon: 'icon-poc circled-icon font-13 me-1',
      isActive: 'false',
      tabID: 3,
      tabTitle: 'Points of Contact',
    },
    {
      content: <SettingsPMG 
      assignedComponentOptions={assignedComponentOptions}
      initialMajcomOptions={initialMajcomOptions}
      initialSectionOptions={initialSectionOptions} 
      roleContext={roleContext}
      visibleSquadrons={visibleSquadrons}
      />,
      icon: 'icon-pmg circled-icon font-13 me-1',
      isActive: 'false',
      isVisible:
        roleContext.isCPOwner ||
        roleContext.isSectionChief ||
        roleContext.isLeadership ||
        roleContext.isMPFOwner ||
        roleContext.isAssignedComponentOwner ||
        roleContext.isMAJCOMOwner ||
        roleContext.isSectionOwner,
      tabID: 4,
      tabTitle: 'Policy Memos & Guidelines',
    },
    {
      content: <SettingsQuicklinks       
        assignedComponentOptions={assignedComponentOptions}
        initialMajcomOptions={initialMajcomOptions}
        initialSectionOptions={initialSectionOptions} 
        initialSquadronOptions={initialSquadronOptions}
        roleContext={roleContext}
        visibleSquadrons={visibleSquadrons} 
      />,
      icon: 'icon-quicklinks2 circled-icon font-13 me-1',
      isActive: 'false',
      tabID: 5,
      tabTitle: 'Quick Links',
    },
    {
      content: <SettingsQA 
      assignedComponentOptions={assignedComponentOptions}
      initialMajcomOptions={initialMajcomOptions}
      initialSectionOptions={initialSectionOptions} 
      initialSquadronOptions={initialSquadronOptions}
      roleContext={roleContext}
      visibleSquadrons={visibleSquadrons}
      />,
      icon: 'icon-qa circled-icon font-13 me-1',
      isActive: 'false',
      tabID: 6,
      tabTitle: 'Q & A',
    },
  ])

  useEffect(()=> {

    setTableItems([
      {
        content: <SettingsAnnouncements 
        assignedComponentOptions={assignedComponentOptions}
        initialMajcomOptions={initialMajcomOptions}
        initialSectionOptions={initialSectionOptions} 
        initialSquadronOptions={initialSquadronOptions}
        roleContext={roleContext}
        visibleSquadrons={visibleSquadrons}
        />,
        icon: 'icon-announcements circled-icon font-13 me-1',
        isActive: 'true',
        tabID: 0,
        tabTitle: 'Announcements',
      },
      {
        content: <SettingsCalendar 
        assignedComponentOptions={assignedComponentOptions}
        initialMajcomOptions={initialMajcomOptions}
        initialSectionOptions={initialSectionOptions} 
        roleContext={roleContext}
        visibleSquadrons={visibleSquadrons}
        />,
        icon: 'icon-calendar circled-icon font-13 me-1',
        isActive: 'false',
        tabID: 1,
        tabTitle: 'Calendar',
      },
      {
        content: <SettingsKnowledgeBase
        assignedComponentOptions={assignedComponentOptions}
        initialMajcomOptions={initialMajcomOptions}
        initialSectionOptions={initialSectionOptions} 
        initialSquadronOptions={initialSquadronOptions}
        roleContext={roleContext}
        visibleSquadrons={visibleSquadrons}
        />,
        icon: 'icon-knowledge-graph circled-icon font-14 me-1',
        isActive: 'false',
        tabID: 2,
        tabTitle: 'Knowledge Base',
      },
      {
        content: <SettingsPOC
        assignedComponentOptions={assignedComponentOptions}
        initialMajcomOptions={initialMajcomOptions}
        initialSectionOptions={initialSectionOptions} 
        initialSquadronOptions={initialSquadronOptions}
        roleContext={roleContext}
        visibleSquadrons={visibleSquadrons}
        />,
        icon: 'icon-poc circled-icon font-13 me-1',
        isActive: 'false',
        tabID: 3,
        tabTitle: 'Points of Contact',
      },
      {
        content: <SettingsPMG
        assignedComponentOptions={assignedComponentOptions}
        initialMajcomOptions={initialMajcomOptions}
        initialSectionOptions={initialSectionOptions}
        roleContext={roleContext}
        visibleSquadrons={visibleSquadrons}
        />,
        icon: 'icon-pmg circled-icon font-13 me-1',
        isActive: 'false',
        isVisible:
          roleContext.isCPOwner ||
          roleContext.isSectionChief ||
          roleContext.isLeadership ||
          roleContext.isMPFOwner ||
          roleContext.isAssignedComponentOwner ||
          roleContext.isMAJCOMOwner ||
          roleContext.isSectionOwner,
        tabID: 4,
        tabTitle: 'Policy Memos & Guidelines',
      },
      {
        content: <SettingsQuicklinks
        assignedComponentOptions={assignedComponentOptions}
        initialMajcomOptions={initialMajcomOptions}
        initialSectionOptions={initialSectionOptions} 
        initialSquadronOptions={initialSquadronOptions}
        roleContext={roleContext}
        visibleSquadrons={visibleSquadrons}
        />,
        icon: 'icon-quicklinks2 circled-icon font-13 me-1',
        isActive: 'false',
        tabID: 5,
        tabTitle: 'Quick Links',
      },
      {
        content: <SettingsQA
        assignedComponentOptions={assignedComponentOptions}
        initialMajcomOptions={initialMajcomOptions}
        initialSectionOptions={initialSectionOptions} 
        initialSquadronOptions={initialSquadronOptions}
        roleContext={roleContext}
        visibleSquadrons={visibleSquadrons} 
        />,
        icon: 'icon-qa circled-icon font-13 me-1',
        isActive: 'false',
        tabID: 6,
        tabTitle: 'Q & A',
      },
    ])

  }, [
    assignedComponentOptions, 
    initialMajcomOptions, 
    initialSectionOptions, 
    initialSquadronOptions,
    roleContext
  ])

  const tabsMinHeight = tableItems.length * 55

  const [tabsContentHeight, setTabsContentHeight] = useState<number>(0)
  window.addEventListener('resize', handleWindowResize)
  useEffect(() => {
    // Get header height based on attribute or tag
    handleWindowResize()
  }, [])
  function handleWindowResize() {
    // const tabsminheight: any = (tableItems.length) * 55
    setTabsContentHeight(tabsMinHeight)
  }
  useEffect(() => {
    // Update CSS variable when headerHeight changes
    document.documentElement.style.setProperty('--tabsconentmin-height', `${tabsContentHeight}px`)
  }, [tabsContentHeight])

  const handleTabSelect = (index) => {
    setActiveTab(index)
  }
  return (
    <div className='container'>
      <div className='row'>
        <div
          className='shadow card mt-0 p-0 tabscontent-height'
          style={{ minHeight: tabsMinHeight + 16 }}
        >
          <Vtabs
            anchorclass='title-color20 font-14 poppins-semibold text-capitalize'
            className='w-100 h-100'
            items={tableItems}
            mainTabsclass='card-body v-tabs'
            onTabSelected={handleTabSelect}
            tablistclassName='w-100'
            vtabscontentclassName='w-100 border-left4 ps-lg-4 tabscontntinheight'
          />
        </div>
      </div>
    </div>
  )
}
export default ContentManagement
